import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='app-footer'>
      <div className='footer-content'>
        <p className='footer-text'>© 2025 Movie Quiz Generator</p>
        <p className='footer-contact'>
          Contact: <a href='mailto:aarkmediagroup@gmail.com'>aarkmediagroup@gmail.com</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
